var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.056,
    height: 87.644,
    viewBox: "0 0 50.056 87.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-608.512 -1104.21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(608.512 1104.21)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 79.379)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.848,205.436a.94.94,0,0,1-.94.94H321.759a.94.94,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94h34.149a.94.94,0,0,1,.94.94Z",
    transform: "translate(-320.819 -204.496)",
    fill: "#282538"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.856,29.46V83.086a.433.433,0,0,1-.433.433H346.743a.433.433,0,0,1-.433-.433V29.46h-1.3V83.086a1.731,1.731,0,0,0,1.731,1.73h11.681a1.73,1.73,0,0,0,1.73-1.73V29.46Z",
    transform: "translate(-334.933 -25.897)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.842 20.276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.772,72.683h-2.017c0-1.069-2.646-2.622-6.791-2.622s-6.791,1.553-6.791,2.622h-2.017c0-2.644,3.787-4.639,8.808-4.639S359.772,70.039,359.772,72.683Z",
    transform: "translate(-342.156 -68.044)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.955,25.561h-2.5c0-1-1.851-2.446-5.718-2.446s-5.718,1.449-5.718,2.446h-2.5c0-2.467,3.532-4.327,8.215-4.327S359.955,23.094,359.955,25.561Z",
    transform: "translate(-343.524 -21.234)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.513 72.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.622,
    height: 8.18,
    rx: 1.383,
    fill: "#282538"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.622,
    height: 8.18,
    rx: 1.383,
    transform: "translate(28.652)",
    fill: "#282538"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 29.543,
    height: 5.226,
    rx: 2.613,
    transform: "translate(2.878 73.805)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 24.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.3,
    height: 53.455,
    rx: 15.834,
    fill: "#3a4151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.4,129.6c.233-.45.469-.9.7-1.35,1.843-3.652,3.577-7.362,5.13-11.147,1.286-3.134,2.3-6.411,3.764-9.466,3.025-6.306,7.569-11.4,11.973-16.749,3.07-3.726,5.856-7.694,8.908-11.435a6.828,6.828,0,0,0-4.688-1.862H328.6a6.858,6.858,0,0,0-6.858,6.858v39.738A6.841,6.841,0,0,0,324.4,129.6Z",
    transform: "translate(-321.743 -77.591)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 25.618,
    height: 43.772,
    rx: 4.657,
    transform: "translate(4.841 4.841)",
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.043,84.449v2.42H355.53a6.858,6.858,0,0,1-6.858-6.858v-2.42h1.513A6.858,6.858,0,0,1,357.043,84.449Zm-28.442,46.6h1.513v-2.42a6.858,6.858,0,0,0-6.858-6.858h-1.513v2.42A6.858,6.858,0,0,0,328.6,131.046Zm28.442-6.858v-2.42H355.53a6.858,6.858,0,0,0-6.858,6.858v2.42h1.513A6.858,6.858,0,0,0,357.043,124.187ZM330.114,80.011v-2.42H328.6a6.858,6.858,0,0,0-6.858,6.858v2.42h1.513A6.858,6.858,0,0,0,330.114,80.011Z",
    transform: "translate(-321.743 -77.591)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.606,87.119V85.505a6.058,6.058,0,0,1,6.051-6.051h.706Z",
    transform: "translate(-322.799 -78.647)",
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.052 4.841)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.714)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.714,88.939v43.43a2,2,0,0,0,.807.171h.1V88.768h-.1A2.007,2.007,0,0,0,335.714,88.939Z",
    transform: "translate(-335.714 -88.768)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.289 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.081,132.369V88.939a2.007,2.007,0,0,0-.807-.171h-.1V132.54h.1A2,2,0,0,0,388.081,132.369Z",
    transform: "translate(-387.173 -88.768)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.908,
    height: 43.772,
    fill: "#252e3f"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.842 24.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.007,78.7a1.294,1.294,0,0,1-1.294,1.294h-7.026a1.294,1.294,0,0,1-1.294-1.294h0a1.294,1.294,0,0,1,1.294-1.294h7.026a1.294,1.294,0,0,1,1.294,1.294Z",
    transform: "translate(-351.392 -77.404)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.549,78.566a.647.647,0,0,0-.647-.647h-4.816a.647.647,0,0,0-.646.647h0a.646.646,0,0,0,.646.646H360.9a.647.647,0,0,0,.647-.646Z",
    transform: "translate(-353.687 -77.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.883 0.412)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.723,
    height: 0.891,
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.723,
    height: 0.891,
    transform: "translate(1.042)",
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.723,
    height: 0.891,
    transform: "translate(2.084)",
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.723,
    height: 0.891,
    transform: "translate(3.127)",
    fill: "#525568"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630.516 1151.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 38.778)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.58,245.112a1.017,1.017,0,0,1-1.017,1.017H470.544a1.017,1.017,0,0,1-1.017-1.017h0a1.017,1.017,0,0,1,1.017-1.017h26.019a1.017,1.017,0,0,1,1.017,1.017Z",
    transform: "translate(-469.527 -244.095)",
    fill: "#282538"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.439 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.284,158.881h-3.2c-1.035,0-1.873,1.347-1.873,3.01v9.362c0,1.662.839,3.01,1.873,3.01h3.2c1.034,0,1.873-1.348,1.873-3.01v-9.362C499.157,160.228,498.319,158.881,497.284,158.881Zm1.193,11.089c0,1.207-.674,2.185-1.507,2.185H494.4c-.832,0-1.507-.978-1.507-2.185v-6.8c0-1.207.674-2.185,1.507-2.185h2.575c.832,0,1.507.978,1.507,2.185Z",
    transform: "translate(-482.325 -158.881)",
    fill: "#252e3f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.269,202.952v-23a9.914,9.914,0,0,0-9.914-9.915h-6.243a9.915,9.915,0,0,0-9.915,9.915v23a1.836,1.836,0,0,0,1.836,1.836h22.4A1.836,1.836,0,0,0,497.269,202.952Z",
    transform: "translate(-470.876 -168.464)",
    fill: "#252e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.205,200.309V176.741a10.159,10.159,0,0,0-10.159-10.159h-6.4a10.159,10.159,0,0,0-10.159,10.159v23.568a1.881,1.881,0,0,0,1.881,1.882h22.952A1.881,1.881,0,0,0,497.205,200.309Z",
    transform: "translate(-470.491 -166.582)",
    fill: "#3a4151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.205,177.734v-.993a10.159,10.159,0,0,0-10.159-10.159h-6.4a10.159,10.159,0,0,0-10.159,10.159v.993Z",
    transform: "translate(-470.491 -166.582)",
    fill: "#525568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.867,177h6.4a9.027,9.027,0,0,0,7.473-3.966,9.027,9.027,0,0,0-7.472-3.967h-6.4a9.028,9.028,0,0,0-7.473,3.967A9.027,9.027,0,0,0,483.867,177Z",
    transform: "translate(-473.708 -167.933)",
    fill: "#d8d8da",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.98,175.687a9.046,9.046,0,0,1,8.817-7.076h6.4a9.045,9.045,0,0,1,8.816,7.076h.385a9.422,9.422,0,0,0-9.2-7.452h-6.4a9.422,9.422,0,0,0-9.2,7.452Z",
    transform: "translate(-471.638 -167.483)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.715,
    height: 0.718,
    transform: "translate(0 10.749)",
    fill: "#252e3f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.801 13.785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.837,195.1h.482a1.192,1.192,0,0,0,1.19-1.19v-1.776a.568.568,0,0,0-.567-.567h-1.729a.568.568,0,0,0-.567.567v1.776A1.192,1.192,0,0,0,477.837,195.1Zm-.765-2.966a.141.141,0,0,1,.142-.142h1.729a.141.141,0,0,1,.141.142v1.776a.765.765,0,0,1-.765.765h-.482a.765.765,0,0,1-.765-.765Z",
    transform: "translate(-476.647 -190.477)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.527)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.787,
    height: 1.693,
    fill: "#525568"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.939,195.1h.482a1.192,1.192,0,0,0,1.19-1.19v-1.776a.568.568,0,0,0-.567-.567h-1.729a.568.568,0,0,0-.567.567v1.776A1.192,1.192,0,0,0,517.939,195.1Zm-.765-2.966a.142.142,0,0,1,.142-.142h1.729a.142.142,0,0,1,.142.142v1.776a.765.765,0,0,1-.765.765h-.482a.765.765,0,0,1-.765-.765Z",
    transform: "translate(-516.749 -190.477)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.527)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.787,
    height: 1.693,
    fill: "#525568"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.955 19.403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.893,
    height: 0.282,
    transform: "translate(0.268 0.128)",
    fill: "#d8d8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.341,203.556l-.172-1.272h.146v-.764h-.7v.764h.146l-.172,1.272Z",
    transform: "translate(-472.589 -201.52)",
    fill: "#f1b14f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.746,202.3v-.624h.608Z",
    transform: "translate(-472.675 -201.604)",
    fill: "#d8d8da"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.818 11.314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.04,185.78l-.172-1.272h.146v-.764h-.7v.764h.146l-.172,1.272Z",
    transform: "translate(-472.288 -183.744)",
    fill: "#f1b14f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.445,184.523V183.9h.608Z",
    transform: "translate(-472.373 -183.828)",
    fill: "#d8d8da"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.1ec3a0ab.svg";
export { ForwardRef as ReactComponent };